var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",attrs:{"dark":""}},[_c('Scene',{attrs:{"sphereImg":_vm.sphereImg}}),_c('Projects',{on:{"updateimg":function($event){_vm.sphereImg = $event}}}),_c('h1',[_vm._v(_vm._s(_vm.sphereImg))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }